<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Parables of the Kingdom
                    </h2>

                    <p>Discover what the Kingdom of Heaven is like through five stories that Jesus told.</p>

                    <h5>
                        Series Aims
                    </h5>
                    <ul>
                        <li>To understand why Jesus spoke in parables.</li>
                        <li>
                            To explore the nature of God's heavenly kingdom and what it means to be a part of that kingdom.
                        </li>
                        <li>
                            To understand how the expectation of the final consummation of the kingdom should impact the Christian life in the present.
                        </li>
                    </ul>

                    <h5 class="mt-4">
                        Series Overview
                    </h5>
                    <p>
                        This series looks at five parables that Jesus told to help his hearers understand what the
                        Kingdom of Heaven is like. They explore the arrival, nature, value and growth of the kingdom.
                        They also challenge many preconceived ideas about who will be a part of the
                        kingdom and what it means to be a member.
                    </p>

                    <h5 class="mt-4">
                        Series Outline
                    </h5>
                    <p>Lesson 1 - The Sower (Matthew 13:1-23)</p>
                    <p>Lesson 2 - The Weeds (Matthew 13:24-30, 36-43)</p>
                    <p>Lesson 3 - The Yeast (Matthew 13:33-35)</p>
                    <p>Lesson 4 - The Hidden Treasure & Pearl (Matthew 13:44-46)</p>
                    <p>Lesson 5 - The Wedding Banquet (Matthew 22:1-14)</p>
                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "ParablesOfTheKingdom",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Parables of the Kingdom`,
            meta: [
                {
                    name: 'description',
                    content: "Discover what the Kingdom of Heaven is like through five stories that Jesus told.",
                },
            ],
        };
    },
};
</script>
